import styled, { css } from 'styled-components';
import neutral from '../../themes/neutral/index.js';
import { AccordionType } from './Accordion.types.js';

var defaultColors = css(["color:", ";background-color:transparent;&:focus{outline:none;box-shadow:0px 0px 2px 2px ", ";}&:hover{background-color:", ";}"], function (props) {
  return props.theme.accordion["default"].color;
}, function (props) {
  return props.theme.accordion["default"].focusColor;
}, function (props) {
  return props.theme.accordion["default"].hoverColor;
});
var darkModeColors = css(["color:", ";background-color:", ";&:focus{outline-color:", ";}&:hover{background-color:", ";}"], function (props) {
  return props.theme.accordion.darkMode.color;
}, function (props) {
  return props.theme.accordion.darkMode.bgColor;
}, function (props) {
  return props.theme.accordion.darkMode.focusColor;
}, function (props) {
  return props.theme.accordion.darkMode.hoverColor;
});
var StyledAccordion = styled.ul.withConfig({
  displayName: "Accordionstyles__StyledAccordion",
  componentId: "sc-55v6xg-0"
})(["margin:0;padding:0;list-style:none;background-color:transparent;border:0;font-family:", ";font-size:", ";line-height:", ";font-weight:", ";"], function (props) {
  return props.theme.accordion.fontFamily;
}, function (props) {
  return props.theme.accordion.fontSize;
}, function (props) {
  return props.theme.accordion.lineHeight;
}, function (props) {
  return props.theme.accordion.fontWeightTitle;
});
var StyledAccordionItem = styled.li.withConfig({
  displayName: "Accordionstyles__StyledAccordionItem",
  componentId: "sc-55v6xg-1"
})([".accordion-button{position:relative;cursor:pointer;padding:", ";padding-right:", ";", " ", " ", " ", " &.", "{", " ", "}.accordion-item-arrow{position:absolute;right:16px;top:50%;margin-top:-8px;}}.accordion-content{overflow:hidden;", " .accordion-content-box{flex:1;font-weight:", ";padding:", ";", " ", "}}&.accordion-open{.accordion-content{height:auto;border-bottom:1px solid ", ";background-color:", ";}}&.accordion-closed{.accordion-button{border-bottom:1px solid ", ";}.accordion-content{visibility:hidden;height:0;}}"], neutral.spacings.medium, neutral.spacings.xxLarge, defaultColors, function (_ref) {
  var disabled = _ref.disabled;
  return disabled && css(["cursor:not-allowed;background-color:transparent;color:", ";&:hover{background-color:", ";}&:focus{outline:none;}"], function (props) {
    return props.theme.accordion["default"].disabledColor;
  }, function (props) {
    return props.theme.accordion["default"].hoverColor;
  });
}, function (_ref2) {
  var darkMode = _ref2.darkMode,
      disabled = _ref2.disabled;
  return darkMode && !disabled && css(["color:", ";background-color:", ";&:hover{background-color:", ";}&:focus{outline-color:", ";}"], function (props) {
    return props.theme.accordion.darkMode.color;
  }, function (props) {
    return props.theme.accordion.darkMode.bgColor;
  }, function (props) {
    return props.theme.accordion.darkMode.hoverColor;
  }, function (props) {
    return props.theme.accordion.darkMode.focusColor;
  });
}, function (_ref3) {
  var darkMode = _ref3.darkMode,
      disabled = _ref3.disabled;
  return darkMode && disabled && css(["cursor:not-allowed;background-color:", ";color:", ";&:hover{background-color:", ";}&:focus{outline-color:", ";}"], function (props) {
    return props.theme.accordion.darkMode.disabledBg;
  }, function (props) {
    return props.theme.accordion.darkMode.disabledColor;
  }, function (props) {
    return props.theme.accordion.darkMode.hoverColor;
  }, function (props) {
    return props.theme.accordion.darkMode.focusColor;
  });
}, AccordionType.DARKMODE, darkModeColors, function (_ref4) {
  var disabled = _ref4.disabled;
  return disabled && css(["cursor:not-allowed;background-color:", ";color:", ";&:hover{background-color:", ";}&:focus{outline-color:", ";}"], function (props) {
    return props.theme.accordion.darkMode.disabledBg;
  }, function (props) {
    return props.theme.accordion.darkMode.disabledColor;
  }, function (props) {
    return props.theme.accordion.darkMode.hoverColor;
  }, function (props) {
    return props.theme.accordion.darkMode.focusColor;
  });
}, function (_ref5) {
  var darkMode = _ref5.darkMode;
  return darkMode && css(["background-color:", ";color:", ";"], function (props) {
    return props.theme.accordion.darkMode.itemBgColor;
  }, function (props) {
    return props.theme.accordion.darkMode.color;
  });
}, function (props) {
  return props.theme.accordion.fontWeightContent;
}, neutral.spacings.medium, function (_ref6) {
  var darkMode = _ref6.darkMode;
  return !darkMode && css(["&.", "{color:", ";background-color:transparent;}&.", "{color:", ";background-color:", ";}&.", "{color:", ";background-color:", ";}"], AccordionType.DEFAULT, function (props) {
    return props.theme.accordion["default"].color;
  }, AccordionType.FILLEDROWS, function (props) {
    return props.theme.accordion["default"].color;
  }, function (props) {
    return props.theme.accordion.filled.itemBgColor;
  }, AccordionType.DARKMODE, function (props) {
    return props.theme.accordion.darkMode.color;
  }, function (props) {
    return props.theme.accordion.darkMode.itemBgColor;
  });
}, function (_ref7) {
  var darkMode = _ref7.darkMode,
      disabled = _ref7.disabled;
  return darkMode && disabled && css(["cursor:not-allowed;background-color:", ";color:", ";&:hover{background-color:", ";}&:focus{outline:none;}"], function (props) {
    return props.theme.accordion.darkMode.itemBgColor;
  }, neutral.colors.grey100, neutral.colors.grey700);
}, neutral.colors.grey300, function (props) {
  return props.theme.accordion["default"].itemBgColor;
}, neutral.colors.grey300);

export { StyledAccordion, StyledAccordionItem };
//# sourceMappingURL=Accordion.styles.js.map
